import { AuthApiError } from '@supabase/supabase-js';
import { useMutation } from '@tanstack/react-query';

import { routes } from 'src/constants/routes';
import { supabaseClient } from 'src/auth/supabase';

export const useForgotPasswordSupabase = () =>
    useMutation<unknown, AuthApiError, { email: string }>({
        mutationKey: ['auth', 'password', 'reset'],
        mutationFn: async ({ email }) => {
            const res = await supabaseClient.auth.resetPasswordForEmail(email, {
                redirectTo: `${window.location.origin}${routes.resetPassword}`,
            });

            if (res.error) throw res.error;

            return res.data;
        },
    });
